import { ChertoExperiments } from 'constants/experiments'
import { getChertoExperimentVariation } from './experimentSelectors'

export const CANCELLATION_OPTIONS_BUCKET = 'cancellation-options'

export function selectCancellationOptionBucket(state: App.State): string | undefined {
  const variation = getChertoExperimentVariation(state, ChertoExperiments.flashCancellationOptions)
  return variation === CANCELLATION_OPTIONS_BUCKET ? variation : undefined
}
